import { pxToRem } from '@/common/utils'
import { alertsData } from '@/data/AlertsData'
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  styled,
  Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { NotificationDetails } from './NotificationDetails'

type MonitorFundsViewProps = {
  from?: string
  to?: string
  amount?: string
  txHash?: string
  contractAddr?: string
  alertName?: string
  alertId: string
  chainId: string
}

export default function MonitorFundsView({
  from,
  to,
  amount,
  txHash,
  contractAddr,
  alertName,
  alertId,
  chainId,
}: MonitorFundsViewProps) {
  const [expanded, setExpanded] = React.useState<string | false>(false)

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false)
  }

  const getFirstAndLastLetters = (str: string) => {
    return str.substring(0, 7) + '...' + str.substring(str.length - 4, str.length)
  }

  return (
    <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
      <AccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Box
          sx={{
            display: 'flex',
            gap: '8px',
            width: '100%',
            overflow: 'hidden',
          }}
        >
          {alertsData.cosmosAlerts[0].icon}
          <Typography sx={{ width: 'auto', flexShrink: 0, paddingLeft: '8px' }}>
            {alertName}
          </Typography>
          {from && (
            <BadgeStyle>
              <span>{getFirstAndLastLetters(from)}</span>
            </BadgeStyle>
          )}
          {to && (
            <BadgeStyle>
              <span>{getFirstAndLastLetters(to)}</span>
            </BadgeStyle>
          )}
        </Box>
      </AccordionSummary>
      <Divider
        sx={{
          backgroundColor: 'rgba(255, 255, 255, 0.12)',
        }}
      />
      <AccordionDetails
        sx={{
          paddingTop: pxToRem(24),
        }}
      >
        <NotificationDetails
          txHash={txHash}
          from={from}
          to={to}
          amount={amount}
          monitorFounds={true}
          alertName={alertName}
          alertId={alertId}
          chainId={chainId}
        />
      </AccordionDetails>
    </Accordion>
  )
}

const BadgeStyle = styled('div')(
  () => `
      background-color: rgba(255, 255, 255, 0.12);
      border-radius: 4px;
      display: flex;
      flex-wrap: wrap;
      border-radius: 8px;
      padding: 2px 10px;
      color: white;
      font-size: 14px;
      `
)
